import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { parse } from 'date-fns';
import { schedulePropTypes } from 'constants/propTypes';

import PillGraph from 'components/PillGraph';
import Message from 'components/Message';

import { deriveReservationsGraphData } from '../Insights.helpers';

import './HistoricalUtilizationTable.scss';

const messages = defineMessages({
  date: {
    id: 'yield-management.insights.historical-utilization-table.date',
    defaultMessage: 'Date',
  },
  earned: {
    id: 'yield-management.insights.historical-utilization-table.earned',
    defaultMessage: 'Earned',
  },
  utilization: {
    id: 'yield-management.insights.historical-utilization-table.utilization',
    defaultMessage: 'Utilization',
  },
});

const renderRow = (pastSchedule, canViewRates, currencyCode, noDirectFillData) => {
  const {
    scheduleDate,
    payouts: { totalRevenue },
  } = pastSchedule;

  const date = parse(scheduleDate, 'yyyy-MM-dd', new Date());

  const graphData = deriveReservationsGraphData(noDirectFillData, pastSchedule);

  return (
    <tr key={date} className="historical-utilization-table__body-row">
      <td className="historical-utilization-table__cell">
        <Message value={date} format="medium" />
      </td>
      <td className="historical-utilization-table__cell historical-utilization-table__graph-container" width="100%">
        <PillGraph name={date.toISOString()} data={graphData} />
      </td>
      {canViewRates && (
        <td className="historical-utilization-table__cell">
          <Message className="historical-utilization-table__mobile-title" message={messages.earned} />
          <Message format="currency-short" currency={currencyCode} value={totalRevenue} />
        </td>
      )}
    </tr>
  );
};

const HistoricalUtilizationTable = ({ canViewRates, currencyCode, noDirectFillData, utilization }) => (
  <table className="historical-utilization-table">
    <thead>
      <tr className="historical-utilization-table__header-row">
        <Message as="th" className="historical-utilization-table__header-cell text--left" message={messages.date} />
        <Message
          as="th"
          className="historical-utilization-table__header-cell text--left"
          message={messages.utilization}
        />
        {canViewRates && (
          <Message as="th" className="historical-utilization-table__header-cell" message={messages.earned} />
        )}
      </tr>
    </thead>
    <tbody>
      {utilization.map(pastSchedule => {
        // We need to map the schedule data from insights into the expected shape for the graph
        // insights helper
        const schedule = {
          ...pastSchedule,
          spots: {
            classpassBooked: pastSchedule.totalReservationsClasspass,
            classpassTotal: pastSchedule.networkCap,
            maxCapacity: pastSchedule.maxCapacity,
            totalBooked: pastSchedule.totalReservations,
          },
        };

        return renderRow(schedule, canViewRates, currencyCode, noDirectFillData);
      })}
    </tbody>
  </table>
);

HistoricalUtilizationTable.propTypes = {
  canViewRates: PropTypes.bool,
  currencyCode: PropTypes.string,
  noDirectFillData: PropTypes.bool,
  utilization: PropTypes.arrayOf(PropTypes.shape(schedulePropTypes)),
};

export default HistoricalUtilizationTable;
